import { useState } from "react";
import { Link } from "react-router-dom";
import { faqItems } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (i: number) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
              Perguntas Frequentes
            </h2>
            <p className="text-foreground-600 text-sm mt-3">
              Tudo o que precisa de saber sobre CSSBuy Spreadsheet
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl border border-background-200 overflow-hidden"
              >
                <button
                  onClick={() => toggle(i)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                >
                  <h3 className="text-foreground-950 font-semibold text-sm md:text-base pr-4">
                    {item.question}
                  </h3>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`ri-${
                        openIndex === i ? "subtract" : "add"
                      }-line text-foreground-500 text-lg transition-transform duration-300`}
                    ></i>
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 text-center">
            <Link
              to="/artigo/cssbuy-spreadsheet-guia-completo"
              className="text-primary-500 font-semibold text-sm hover:text-primary-600 transition-colors duration-200 cursor-pointer inline-flex items-center gap-1"
            >
              Ver Guia Completo
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}